import React, { Component } from 'react';
import { connect } from 'react-redux';
import KnowledgeDialog from './knowledgedialog/index';
import ChatDialog from './chat/index'
import IframeModal from '../../components/IframeModal/index.tsx';
import ExternalQuestionDialog from './externalQuestionDialog/index.js';
import { Range } from 'rc-slider';
import queryParser from 'query-string';
import common from '../../common/common';
import SVGA from 'svgaplayerweb';
import intl from 'react-intl-universal';
import service from './service';
import store from '../../store';
import Watermark from './watermark/index';
import Confirm from './Confirm/index';
import ShareDialog from './shareDialog';
import { toast } from '../../utils/axios';
import { throttle } from '../../utils/utils';
import 'rc-slider/assets/index.css';
import styles from './knowledgePoint.module.scss';
import leftSliderIcon from '../../assets/img/knowledgePoint/cursor_slider-left@2x.png';
import rightSliderIcon from '../../assets/img/knowledgePoint/cursor_slider-right@2x.png';
import SliderCursorIcon from '../../assets/img/knowledgePoint/cursor_stretch-horizontal.png';
import focusIcon from '../../assets/img/knowledgePoint/tags_markers-red@2x.png';
import difficultyIcon from '../../assets/img/knowledgePoint/tags_markers-yellow@2x.png';
import star from '../../assets/img/knowledgePoint/treasure-box.svga';
import hosts from '../../utils/hosts';
import token from '../../store/reducer/token';

// const getAPIUrl = () => {
//   const host = window.location.host;
//   if (host.includes('testd')) {
//     return 'https://testapi.roombox.xdf.cn';
//   } else if (host.includes('test2d')) {
//     return 'https://test2api-roombox.test.xdf.cn';
//   } else if (host.includes('test3d')) {
//     return 'https://test3api-roombox.test.xdf.cn';
//   } else if (host.includes('pred')) {
//     return 'https://preapi.roombox.xdf.cn';
//   } else if (process.env.NODE_ENV === 'development') {
//     return 'https://testapi.roombox.xdf.cn';
//   } else {
//     return 'https://api.roombox.xdf.cn';
//   }
// }

const getIFrameUrl = hosts.ssUrl;
const themeImg = {
  'no-knowledge': {
    'gen': require('../../assets/theme-gen/img/star/no-knowledge-point.png'),
    'mke': require('../../assets/theme-mke/img/star/no-knowledge-point.png')
  }
};
// cid mainId uid role nickName token url language
console.log('href: ', window.location.href)
const searchParam = common.getSearchParam();
let playbackEnv = (window.location.host.includes('test') || process.env.NODE_ENV === 'development') ? 'test' : '';
const playedUrl = `${hosts.apiUrl}/api/video/record/detail`;
const isOnline = (window.location.host.includes('test') || process.env.NODE_ENV === 'development') ? false : true;

// 解码baseInfo
function decodeBaseInfo(baseInfo = '') {
  const strInfo = atob(decodeURIComponent(baseInfo));
  return strInfo ? JSON.parse(strInfo) : {};
}

function generateLogParams(baseInfo, bizCode = searchParam.bizCode) {
  let params = {};
  if(bizCode){
    params.bizCode = bizCode;
  }
  if(baseInfo){
    params = {...params, ...decodeBaseInfo(baseInfo)};
  }
  return params;
};

const rangeHandleStyle = { border: 'none', borderRadius: '0', width: '7px', height: '22px', cursor: `url(${SliderCursorIcon}) 12 12, pointer`, boxShadow: 'none' };
const leftRangeHandleStyle = { ...rangeHandleStyle, background: `url(${leftSliderIcon})`, backgroundSize: '100% 100%' };
const rightRangeHandleStyle = { ...rangeHandleStyle, background: `url(${rightSliderIcon})`, backgroundSize: '100% 100%' };

const formatTime = (second, options) => {
  let hourTen = Math.floor(Math.floor(second / (60 * 60)) / 10);
  let hourDigit = Math.floor(second / (60 * 60)) % 10;
  let minuteTen = Math.floor(Math.floor((second % (60 * 60)) / 60) / 10);
  let minuteDigit = Math.floor((second % (60 * 60)) / 60) % 10;
  let secondTen = Math.floor((second % 60) / 10);
  let secondDigit = Math.floor((second % 60) % 10);
  let mmss = `${minuteTen}${minuteDigit}:${secondTen}${secondDigit}`;
  let HHmmss = `${hourTen}${hourDigit}:${minuteTen}${minuteDigit}:${secondTen}${secondDigit}`;
  if (options && options.format === 'HH:mm:ss') return HHmmss;
  if (!hourTen && !hourDigit) return mmss;
  return HHmmss;
}

let replayKnowledgePointLog;

class KnowledgePoint extends Component {
  popupNoteId = '';
  player = null;
  xdfPlayer = null;
  currentTime = 0;
  markBottom = 60;
  leftSliderValue = 0;
  markOffset = 9; // 进度条左边间距-标记点宽度一半 (12-3)
  controlBarOffsetLeft = 12; // 进度条左边间距
  controlBarOffsetRight = 12; // 进度条右边边间距
  markDialogHalfWidth = 118; // 标记点弹框宽度一半
  recordData = [];
  slsLogger = null;
  slsTime = null;
  slstimeArr = [];
  seekStart = 0;
  addKnoPointBegin = 0;
  editKnowPointBegin = 0;
  constructor(props) {
    super(props);
    this.progressRef = React.createRef();
    this.classroomId = +searchParam.cid || 491565548;
    this.timerId = null;
    this.timerId2 = null;
    this.role = +searchParam.role || 1;
    this.playTotalTime = 0;
    this.isAward = false;
    this.state = {
      playerUrl: '',   // 回放地址
      videoShareType: 0, // 0 私有 1 公开 2 公开且游客
      isLogin: false, // 是否登录
      nickName: '', // 昵称
      markPosition: [0, this.markBottom],
      videoId:'', // videoId
      appId: '',
      appSecret:'',
      vodAddr:'',
      isQuickRead: false, // 是否在进行知识点速览
      totalTime: 1, // 视频总时长
      showKnowledgeDialog: false,
      showNewMarkDialog: false,
      showChatDialog: false,
      isPlayingId: '', // 指的是速览时的id 或 手动点击播放时候的id
      isUpdateKno: false,
      selecting: false,
      markList: [],
      knowledgeList: [],
      isEditingKnowPoint: null,
      currentMark: '',
      sliderWidth: 1100,
      sliderValue: [0, 100],
      recordList: [], // 学生观看详情
      previewKnoPointId: '',
      controlBarWidth: 1000,
      seenTime: 0,
      needTime: 0,
      progressWidth: 0,
      allowCross: true,
      followControlVisible: false,
      starNum: '',
      showStarNum: false,
      isValid: true,
      showShare: false,
      shareNoteId: 0,
      shareUrl: '',
      previewKnoPosition: { width: '420px', position: 'fixed', height: 'auto', bottom: '60px' },
      noteList: [],
      isAnswerMini: false,
      previewAnswerSeq: '',
      previewAnswerId: '',
      showAnswerSheetDialog: false,
      updateAnswer: false,
      quizList: [],
      quizItem: '',
      selectedValue: '',
      selectShow: false,
      testQuizList: [],
      previewAnswerPosition: {
        position: 'fixed', bottom: '84px', left: '74px', width: '320px', height: '400px', background: '#FFFFFF',
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.2)', borderRadius: '16px', opacity: 0.97
      },
      currentExternalQuestion: null,
      // 讲义信息
      handoutInfo: {
        show: false, // 是否展示讲义按钮
        url: '' // 讲义地址
      },
      // 讲义弹窗信息
      handoutModalInfo: {
        visible: false,
        wrapStyle: {}
      },
      externalQuestionList: [], // 第三方机构发送的答题列表
      deleteConfirmItemId: null,
      isTipNearTop: false, // 是否靠近顶部
    }
    this.handoutBtnRef = React.createRef();
  }
  async componentDidMount() {
    try {
      // 嵌套的iTaech课件 是xdf.cn domain
      document.domain = window.location.host.includes("metcom") ? 'metcom.com.cn':'xdf.cn';
      const tourData = await service.getIsTour({ classroomId: +searchParam.cid || 0 });
      this.setState({
        videoShareType: tourData.videoShareType
      })
      // 私有或公开状态 没有token时跳转登录页
      if (this.state.videoShareType !==2 && !this.props.token) {
        console.log('未登录跳转登录');
        this.login();
      }
      // 有token走正常功能
      if (this.props.token) {
        console.log('hasToken', this.props.token);
        const userData = await this.fetchUserInfo(); // 刷新token并获取用户信息
        console.log(userData, 'data======');
        // 如何该接口又返回则说明有效登录
        if (userData) {
          this.setState({ isLogin: true, nickName: userData?.nickName || ''}) 
        }
        this.role = userData.roleId;
        let data = await service.getClassroom({ classroomId: +searchParam.cid || 0, module: 'playback', queryLiveStreamUrl: true, checkBlacklist: false });
        let playback = data?.playback || {}; 
        this.reportLog(playback?.baseInfo); // 日志上报
        let templateId = playback?.templateId || 0;       
        playback && this.setState({
          role: playback?.roleId,
          videoId: playback?.mediaIds && playback?.mediaIds[0] || '',
          playerUrl: playback?.videoUrl && playback?.videoUrl[0] || '',
        });
        // 非美刻走videoID  没有appId appSecret vodAddr走URL
        if (process.env.ORG !== 'meike') {
          try {
            let boardsData = await service.getBoardsinfo({ boardKeys: ['Vod'] });
            let boardsDataValue = {};
            const { boards } = JSON.parse(boardsData);
            if (Array.isArray(boards) && boards.length > 0 && boards[0].value) {
              boardsDataValue = JSON.parse(boards[0].value);
            }
            this.setState({
              appId: boardsDataValue.appId || '',
              appSecret: boardsDataValue.appSecret || '',
              vodAddr: boardsDataValue.domain || ''
            });
          } catch (error) {
            console.log('getBoardsinfo', error);
          }
        }
        if (templateId === 100) {
          let bookId = 0;
          try {
            let data = await service.getMediaInfo(searchParam.cid);
            bookId = data.mediaId || 0;
          } catch (error) {
            console.error(`${searchParam.cid} getMediaInfo  error:`, error);
          }
          let host = window.location.host;
          let h5Host = 'https://roombox.xdf.cn';
          if (process.env.NODE_ENV === 'development') {
            h5Host = 'https://testwww.roombox.xdf.cn';
          } else if (host.indexOf('testd') !== -1) {
            h5Host = 'https://testwww.roombox.xdf.cn';
          } else if (host.indexOf('test2d') !== -1) {
            h5Host = 'https://test2www-roombox.test.xdf.cn';
          } else if (host.indexOf('test3d') !== -1) {
            h5Host = 'https://test3www-roombox.test.xdf.cn';
          } else if (host.indexOf('pred') !== -1) {
            h5Host = 'https://prewww.roombox.xdf.cn';
          }
          let h5Url = `${h5Host}/mpc/recording?mode=class&id=${bookId}&token=${this.props.token}&cid=${searchParam.cid}&uid=${searchParam.uid}&role=${searchParam.role}`;
          window.location.href = h5Url;
          return;
        }
      }
      // 游客且没有登录 URL从tour接口取
      if (this.state.videoShareType === 2 && !this.state.isLogin) {
        this.setState({
          playerUrl: tourData.videoUrl[0]
        });
      }
    } catch (error) {
      console.error('index_error', error);
      return;
    }
    // 获取不到播放源 提示信息
    console.log('beforeplayer');
    if (!this.state.videoId && !this.state.playerUrl) {
      toast('回放暂未生成');
      return;
    }
    // 建立播放器
    let xdfPlayer = new window.XdfPlayer({
      "id": "xdf-player",
      "xdfVideo": {
        "video_id": this.state.videoId || '',
        "app_id": this.state.appId || '',
        "app_secret": this.state.appSecret || '',
        "vod_addr": this.state.vodAddr || '', 
        "origin_url": this.state.playerUrl || '',
      },
      //"source": this.state.playerUrl,
      "width": "100%",
      "height": "100%",
      "autoplay": true,
      "trackLog": true,
      "keyShortCuts":true,//键盘控制
      "controlBarVisibility": "always",
      "slsOption": {
        "host": "cn-beijing.log.aliyuncs.com",
        "project": isOnline ? 'xdf-player': 'xdf-player-test',
        "sdkLogStore": 'sdk_log',
      },
      
      "roomboxSubOrgId": '',
      "roombox_class_type": "",
      "roombox_main_cid": searchParam.mainId || 0,
      "roombox_role": "",
      "roombox_sdk_version": "",
      "roombox_sid": "",
      "roombox_uid": searchParam.uid || 0,
      "roombox_cid": searchParam.cid || 0,
      "skinLayout": [
        {
          "name": "bigPlayButton",
          "align": "blabs",
          "x":"50%",
          "y":"50%"
        },
        {
          "name": "H5Loading",
          "align": "cc"
        },
        {
          "name": "errorDisplay",
          "align": "tlabs",
          "x": 0,
          "y": 0
        },
        {
          "name": "infoDisplay"
        },
        {
          "name": "tooltip",
          "align": "blabs",
          "x": 0,
          "y": 56
        },
        {
          "name": "thumbnail"
        },
        {
          "name": "controlBar",
          "align": "blabs",
          "x": 0,
          "y": 0,
          "isSac": true,
          "children": [
            {
              "name": "progressSac",
              "align": "blabs",
              "x": 0,
              "y": 44
            },
            {
              "name": "backwardfastSeek",
              "align": "tl",
              "x": 0,
              "y": 12
            },
            {
              "name": "playButton",
              "align": "tl",
              "x": 5,
              "y": 12
            },
            {
              "name": "forwardfastSeek",
              "align": "tl",
              "x": 8,
              "y": 12
            },
            {
              "name": "timeDisplay",
              "align": "tl",
              "x": 10,
              "y": 7
            },
            // {
            //   "name": "setting",
            //   "align": "tr",
            //   "x": 15,
            //   "y": 12,
            // },
            {
              "name": "volume",
              "align": "tr",
              "x": 5,
              "y":10,
              "isSac":true
            },
            {
              'name':'speedButton',
              'align':'tr',
              "x": 32,
              "y": 7
            },
          ]
        }
      ],
    }, function (xdfPlayer) {
        console.log("The xdfPlayer is created", xdfPlayer);        
    });

    this.xdfPlayer = xdfPlayer;

    //this.player = player;
    //this.player.start();
    // 侦听视频时长
    // player.once('loadedmetadata', value => {
    //   console.log('loadedmetadata totalTime: ', value.duration, value);
    //   this.setState({totalTime: value.duration})
    //   this.addDotToPlayer();
    // });

    // 在有效登录状态下 正常请求所有数据 打点
    if (this.state.isLogin) {
      await this.getKnoList();  // 获取老师的知识点
      await this.getQuizList();
      this.role === 3 && this.getHandoutInfo(); // 学生获取讲义下载信息
      this.slsLogger = window.AliLogTracker({
        online: isOnline, //生产环境为true，测试环境为false
      });
      this.slsTime = setInterval(()=>
      {
        //if(this.xdfPlayer && this.xdfPlayer.getStatus() !== 'playing') return;
        if(this.slstimeArr.length === 0) return;
        if (this.slstimeArr.length > 5) {
          this.slstimeArr = this.slstimeArr.slice(-5);
        }
        let slsData = {};
        slsData.ts = (new Date()).getTime();
        //console.log('dateutc: ', slsData.ts);
        slsData.event_id = 'RB1000';
        slsData.uid = searchParam.uid;
        slsData.cid = searchParam.cid;
        slsData.record = '['+this.slstimeArr+']';
        slsData.main_id = searchParam.mainId;
        slsData.last_offset=Math.floor(this.xdfPlayer.getCurrentTime());
        this.slsLogger.log('timer', slsData);
        this.slstimeArr = [];
      },5000);

      // 侦听视频时长
      this.xdfPlayer.on('loadeddata', () => {
        let duration = this.xdfPlayer.getDuration();
        console.log('[EVENT]LoadedData: ', duration);
        this.setState({totalTime: duration});
        //设置打点信息      
        this.FetchPlayed();
        
        this.addDotToPlayer();

        var width = this.state.controlBarWidth;
        this.setState({markList:this.handleMarkList(this.state.markList, width)});

        let slsPlaySucess={};
        slsPlaySucess.event_id='RB1015';
        slsPlaySucess.function=1;
        this.slsLogger.log('action', slsPlaySucess);
      });

      //timeupdate
      // let videoDom = this.player.CurVideoDom();
      // videoDom.addEventListener('timeupdate', () => {
      //   console.log('------this.popupNoteId', this.popupNoteId)
      //   console.log(this.player.currentTime);
      //   if (this.player.isUserSeeking) return;
      //   if (this.state.isQuickRead) return;
      //   if (!!this.state.isPlayingId) return;
      //   let note = this.state.noteList.find(n => {
      //     // let diff = this.player.currentTime - n.startTime
      //     // if (diff > 0 && diff < 0.3) return n;
      //     if (this.player.currentTime >= n.startTime && this.player.currentTime <= (n.startTime + 4)) return n;
      //   });
      //   if (!note) return;
      //   if (this.state.knowledgeList.length > 0 && note.noteId === this.state.knowledgeList[this.state.knowledgeList.length - 1].noteId) return;
      //   if (this.popupNoteId === (note.noteId || note.quizId || note.questionId)) return;
      //   this.popupNoteId = note.noteId || note.quizId || note.questionId;
      //   if (note.type === 1) {
      //     let value = note?.noteId;
      //     this.getPreviewKnoPosition(+value);
      //     this.setState({ previewKnoPointId: +value });
      //   }
      //   if (note.type === 2) {
      //     this.onCheckMark(this.state.markList.find(m => m.noteId === note.noteId));
      //   }
      //   if (note.type === 3) {
      //     this.onPreviewAnswer(note.quizSeq, note.quizId)
      //   }
      //   if (note.type === 4) {
      //     this.setState({currentExternalQuestion: {
      //       questionId: note.questionId,
      //       studyUrl: note.studyUrl
      //     }})
      //   }
      //   this.player.pause();
      //   this.player.showDot(true);
      // });
      this.xdfPlayer.on('timeupdate', () => {
        //播放记录
        if(this.xdfPlayer && this.xdfPlayer.getStatus() == 'playing'){
          let slstime = Math.floor(this.xdfPlayer.getCurrentTime());  
          let slslen=this.slstimeArr.length;
          // console.log('slstime', this.slstimeArr);
          if(slslen > 0 && this.slstimeArr[slslen-1]===slstime)
          {
      
          }
          else
          {
            this.slstimeArr.push(slstime);
          }
      }

        //判断是否速览中 当前知识点是否结束
        let currentTimt = this.xdfPlayer.getCurrentTime();
        if(this.state.isQuickRead && this.QuickReadIndex && this.QuickReadIndex.endTime < currentTimt){
          this.playedCallback(this.QuickReadIndex.noteId);
        }
        if (this.xdfPlayer.isSeeking()) return;
        if (this.state.isQuickRead) return;
        if (!!this.state.isPlayingId) return;
        let note = this.state.noteList.find(n => {
          // let diff = this.player.currentTime - n.startTime
          // if (diff > 0 && diff < 0.3) return n;
          currentTimt = this.xdfPlayer.getCurrentTime();
          if (currentTimt >= n.startTime && currentTimt <= (n.startTime + 4)) return n;
        });
        if (!note) return;
        if (this.state.knowledgeList.length > 0 && note.noteId === this.state.knowledgeList[this.state.knowledgeList.length - 1].noteId) return;
        if (this.popupNoteId === (note.noteId || note.quizId || note.questionId)) return;
        this.popupNoteId = note.noteId || note.quizId || note.questionId;
        if (note.type === 1) {
          let value = note?.noteId;
          this.getPreviewKnoPosition(+value);
          this.setState({ previewKnoPointId: +value });
        }
        if (note.type === 2) {
          this.onCheckMark(this.state.markList.find(m => m.noteId === note.noteId));
        }
        if (note.type === 3) {
          this.onPreviewAnswer(note.quizSeq, note.quizId)
        }
        if (note.type === 4) {
          this.setState({currentExternalQuestion: {
            questionId: note.questionId,
            studyUrl: note.studyUrl
          }})
        }
        //this.player.pause();
        //this.player.showDot(true);
        this.Pause();
      });
      // player.on('error', err => {
      //   console.log('player on error: ', JSON.stringify(err));
      // });

      this.xdfPlayer.on('error', data => {
        console.log('player on error: ', data);
        let slsPlay={};
        slsPlay.event_id='RB1015';
        slsPlay.function=2;
        this.slsLogger.log('action', slsPlay);
      });
      // 知识点播放结束事件 -- 此事件不存在
      // player.on('knowledgePointend', id => {
      //   console.log('knowledgePointEnd: ', id);
      //   this.playedCallback(+id);
      // });

      // 鼠标点击知识点上面的click事件
      // player.on('clickPoint', value => {
      //   console.log('clickPoint: ', value);
      //   this.getPreviewKnoPosition(+value);
      //   this.setState({ previewKnoPointId: +value });
      //   //replayKnowledgePointLog('RB1019'); // 点击某个知识点
      // });
      // 快进 快退 拖动滚动条事件
      this.xdfPlayer.on('userSeek', value => {
        console.log('currentTimeChange: ', value)
        this.popupNoteId = '';
        this.finishQuickRead();
        replayKnowledgePointLog('RB1022', { function: 3 }); // 打断的结束速览
      })

      // 快进 快退 拖动滚动条事件
      this.xdfPlayer.on('seekStart', value => {
        this.popupNoteId = '';
        this.finishQuickRead();
        this.seekStart = Math.floor(this.xdfPlayer.getCurrentTime());
        replayKnowledgePointLog('RB1022', { function: 3 }); // 打断的结束速览
      })

      this.xdfPlayer.on('completeSeek', e => {
        let endTime = Math.floor(e.paramData);
        let slsSeek={};
        slsSeek.event_id='RB1014';
        //console.log("start:", this.seekStart, ", end:", endTime);
        if(endTime > this.seekStart)//快进
        {
          slsSeek.function=3;
        }
        else//快退
        {
          slsSeek.function=4;
        }
        this.slsLogger.log('action', slsSeek);
        this.seekStart = 0;
      })

      this.xdfPlayer.on('ended', () => {
        console.log('player ended');
        //this.xdfPlayer.stop();
      } )

      this.xdfPlayer.on('resize', value => {
        var width = value.paramData.width-24;
        this.setState(state => {
          return { sliderWidth: width, markList: this.handleMarkList(state.markList, width), controlBarWidth: width };
        }, () => {
          this.setState({ allowCross: false });
        });
      })
        document.getElementById('knowledgePointPlayback').addEventListener('pointermove', (event) => {
          this.xdfPlayer && this.xdfPlayer.conotrolVisible(true);
          this.setState({ followControlVisible: true });
        });
        document.getElementById('knowledgePointPlayback').addEventListener('pointerleave', () => {
          setTimeout(() => {
            this.xdfPlayer && this.xdfPlayer.conotrolVisible(false);
            this.setState({ followControlVisible: false });
          }, 3000);
        });
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('click', this.handleTipOutsideClick);
      this.role === 3 && await this.handleStarProgress();
      this.role === 3 && this.state.needTime > 0 && !this.isAward && this.handleStarSVGA(1);
      this.role === 3 && this.state.needTime > 0 && !this.isAward && this.handleStarReward();
      replayKnowledgePointLog('RB1013', { function: 1 }); // 进入回放页面
    }
  }

  Play = () => {
    let slsPlay={};
    slsPlay.event_id='RB1014';
    slsPlay.function=1;
    this.slsLogger.log('action', slsPlay);
    this.xdfPlayer.play();
  }

  Pause = () => {
    let slsPause={};
    slsPause.event_id='RB1014';
    slsPause.function=2;
    this.slsLogger.log('action', slsPause);
    this.xdfPlayer.pause();
  }

  Seek = (toTime) => {    
    this.xdfPlayer.seek(toTime);
  }

  FetchPlayed = () => 
  {
    const myHeaders = new Headers({
      'Content-Type': 'application/json',
      'token':this.props.token,
    });

    let classroomId=searchParam.cid;

    const url = playedUrl+'?classroomId='+classroomId;
    //console.log('fetch url: ', url);
    fetch(url, {
      method: 'GET',
      headers: myHeaders,
    })
    .then(response =>
    {
          if (response.status === 200)
          {
            return response.json();
          }
          else
          {
            throw new Error('Something went wrong on api server!');
          }
    })
    .then(response =>
    {
      this.recordData=response.data.record;
      this.currentTime=response.data.last;
      this.startTimeRec=response.data.last;
      this.xdfPlayer.setPlayedRange(this.recordData);
      this.Seek(this.startTimeRec);
    })
    .catch(error =>
    {
          console.error(error);
    });
 }
  // 登录
  login = () => {
    const host = window.location.host;
    let urlHost = ''
    if (host.includes('testd')) {
      urlHost = 'testuc.roombox.xdf.cn';
    } else if (process.env.ORG ==='meike') {
      urlHost = 'uc.mk.metcom.com.cn';
    } else {
      urlHost = 'uc.roombox.xdf.cn';
    }
    // orgId=999
    let loginUrl = `https://${urlHost}/user/authCenter?pure=1&auth=1&language=cn&organizationId=${searchParam.orgId}&from=${window.location.href}`;
    window.location.href = loginUrl;
    return;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleTipOutsideClick);
    clearInterval(this.timerId);
    clearInterval(this.timerId2);
    replayKnowledgePointLog('RB1013', { function: 2 }); // 退出回放页面
  }

  reportLog = (baseInfo, uid) => {
    const logger = window && window.AliLogTracker && window.AliLogTracker({
      platform: process.env.ORG || 'roombox',
      online: isOnline,
    });
    if (logger) {
      const otherParams = generateLogParams(baseInfo, searchParam.bizCode);
      console.log('otherParams', otherParams);
      logger.baseParams = {...logger.baseParams, ...otherParams};
      logger.setUID(this.props.userInfo.userId || +searchParam.uid || 0);
      logger.setCID(+searchParam.cid || 0);
      replayKnowledgePointLog = (eventId, opts) => {
         logger.log('action', { event_id: eventId, ...(opts || null) });
       };
    }
    console.log('logger', logger);
  }

  fetchUserInfo = async () => {
    const res = await service.getEffectiveToken(this.props.token);
    if (res) {
      store.dispatch({
        type: 'SETTOKEN',
        payload: res?.token
      });
      store.dispatch({
        type: 'SET_USERINFO',
        payload: {
          userInfo: res
        }
      });
    }
    return res;
  }

  // 获取讲义信息
  getHandoutInfo = () => {
    service.getHandoutInfo({
      classroomId: searchParam.cid
    }).then(res => {
      this.setState({
        handoutInfo: res
      })
    }).catch(error => {
      console.error(error);
    });
  }
  handleStarReward = () => {
    this.timerId = setInterval(() => {
      let playTime = this.xdfPlayer.getPlayedTotalTime(); //this.player.playedTotalTime;
      this.setState(state => {      
        let progressWidth = Math.min(100, ((this.playTotalTime + playTime) / state.needTime * 100));
        return { seenTime: this.playTotalTime + playTime, progressWidth };
      }, async () => {
        if (this.state.seenTime >= this.state.needTime) {
          clearInterval(this.timerId);
          this.timerId2 = setInterval(async () => {
            let res = await service.onStarReward({ classroomId: this.classroomId });
            if (res && res.success) { // 可以开宝箱
              clearInterval(this.timerId);
              clearInterval(this.timerId2);
              this.handleStarSVGA();
            }
          }, 5000);
        }
      });
    }, 1000);
  }
  handleStarSVGA = frame => {
    let playerSVG = new SVGA.Player('#starReward');
    let parser = new SVGA.Parser('#starReward');
    parser.load(star, videoItem => {
      playerSVG.loops = 1;
      !frame && (playerSVG.clearsAfterStop = false);
      playerSVG.fillMode = false;
      playerSVG.setVideoItem(videoItem);
      playerSVG.startAnimation();
      frame && playerSVG.stepToFrame(frame, false);
      playerSVG.onFrame(currentFrame => {
        if (currentFrame === 16) this.setState({ showStarNum: true });
      })
    });
  }

  handleStarProgress = async () => {
    let [info, detail] = await Promise.all([service.getReplayInfo({ classroomId: this.classroomId }), this.getRecordDetail()]);
    if (info && !info.isValid) {
      this.setState({ isValid: false });
      //setTimeout(() => { this.player.pause(); return; }, 4000);
      setTimeout(() => { this.Pause(); return; }, 4000);
    }
    let arr = detail.record.map(r => (r[1] - r[0]));
    let seenTime = arr.length ? arr.reduce((prev, cur) => (prev + cur)) : 0;
    //this.playTotalTime = seenTime;//播放器已计算
    let duration = this.xdfPlayer.getDuration();
    let needTime = duration ? duration : info.threshold;//应需求方，改为实际时长的百分比
    if (info && info.isAward) {
      this.setState({ starNum: info.starNum });
      this.isAward = true;
      needTime > 0 && this.handleStarSVGA();
    }
    let progressWidth = Math.min(100, Math.round(seenTime / needTime * 100));
    this.setState({ seenTime, needTime, progressWidth });
  }
  getPreviewKnoPosition = id => {
    const offsetWidth = document.documentElement.offsetWidth;
    const i = offsetWidth / this.state.totalTime; // 每秒多少像素
    const kno = this.state.knowledgeList.find(item => item.noteId === id);
    const { startTime } = kno;
    let left = startTime * i;
    if (left > offsetWidth - 420) left = offsetWidth - 420
    this.setState({ previewKnoPosition: { ...this.state.previewKnoPosition, left }});
  }
  getKnoList = async () => {
    const { cid: classroomId } = searchParam;
    const res = await service.getKnoList({ classroomId: +classroomId });
    if (!Array.isArray(res.quizList) || !Array.isArray(res.noteList)) return;
    // 学生noteList 有知识点和标记点 老师获取只有是知识点
    const knowledgeList = [];
    const markList = [];
    // const externalQuestionList = [];
    const testQuizList = res.quizList.sort((a, b) => a.sendTime - b.sendTime);
    res.noteList.forEach(item => {
      if (item.type === 1) knowledgeList.push(item);
      if (item.type === 2) markList.push(item);
    })
    this.setState(state => {
      return {
        noteList: [...res.noteList, ...res.quizList.map(l => ({ ...l, type: 3, startTime: l.sendTime })), ...(res.externalQuestionList || []).map(item => ({...item, type: 4}))].sort((a, b) => a.startTime - b.startTime),
        knowledgeList: knowledgeList.sort((a, b) => a.startTime - b.startTime),
        testQuizList,
        markList: this.handleMarkList(markList.sort((a, b) => a.startTime - b.startTime), state.controlBarWidth),
        externalQuestionList: (res.externalQuestionList || []).sort((a, b) => a.startTime - b.startTime)
      };
    });
  }
  getRecordDetail = async () => {
    return await service.getRecordDetail({ classroomId: this.classroomId });
  }
  // 往播放器里添加知识点时间
  addDotToPlayer = () => {
    const { knowledgeList, testQuizList, externalQuestionList } = this.state;
    var markers = [];
    knowledgeList.length && knowledgeList.forEach(item => {
      const { startTime, endTime, noteId } = item;
      //this.player.addProgressDot(startTime, noteId, endTime - startTime); // 添加知识点接口 第一个参数要传秒  比如01:20 传80
      markers.push({offset:Math.floor(startTime),text:'',nodeId: noteId});
    });
    testQuizList.length && testQuizList.forEach(item => {//答题卡
      const { sendTime, quizSeq } = item; 
      //this.player.addProgressDot(sendTime, quizSeq, 2, { type: 3 });
      markers.push({offset:Math.floor(sendTime),text:'',nodeId: quizSeq, color: '#FFCA8B'});
    });
    externalQuestionList.length && externalQuestionList.forEach((item) => {
      const { startTime,questionId } = item;
      //this.player.addProgressDot(startTime, questionId, 2 , {type : 4});
      markers.push({offset:Math.floor(startTime),text:'',nodeId: questionId});
    })
    //console.log("----add Markers:", markers);
    this.xdfPlayer.setProgressMarkers(markers);
  }
  handleCancelKnoDialog = () => {
    this.setState({
      showKnowledgeDialog: !this.state.showKnowledgeDialog,
      isQuickRead: false,
      isPlayingId: '', // 指的是速览时的id 或 手动点击播放时候的id
      isUpdateKno: false,
      selecting: false,
      isEditingKnowPoint: null
    })
    replayKnowledgePointLog('RB1021', { function: 2 }); // 关闭知识点页面
  }
  openKnowledgeDialog = () => {
    this.setState({ showKnowledgeDialog: !this.state.showKnowledgeDialog });
    replayKnowledgePointLog('AC3501', {click: '进入知识点列表', type: '无'});
    // replayKnowledgePointLog('RB1021', {function: 1}); // 打开知识点页面
  }
  onTextareaChange = event => {
    this.setState({ isEditingKnowPoint: { ...this.state.isEditingKnowPoint, note: event.target.value }});
  }
  handleKnowledge = () => {
    this.setState({ isUpdateKno: true });
    this.addKnoPointBegin = Math.floor(Date.now() / 1000);
    replayKnowledgePointLog('AC3502', { click: '新增知识点', type: '入口', desc: '旧回放' });
    // replayKnowledgePointLog('RB1024', {function: 1}); // 点击新增知识点
  }
  onSelect = () => {
    this.setState(state => {
      let t1 = state.knowledgeList.slice(-1)[0]?.endTime || 0;
      let t2 = Math.min(state.totalTime, t1 + state.totalTime * 5 / 100);
      let p1 = (t1 / state.totalTime * 100).toFixed(2);
      let p2 = (t2 / state.totalTime * 100).toFixed(2);
      return {
        sliderWidth: state.controlBarWidth,
        sliderValue: [p1, p2],
        selecting: true,
        isEditingKnowPoint: { startTime: t1, endTime: t2, note: state.isEditingKnowPoint?.note || ''}
      };
    }, () => {
      this.setState({ allowCross: false });
    });
  }
  delPlayerMarkers = async nodeId=>{
    var currentMarkers = this.xdfPlayer.getProgressMarkers();    
    for (var i = 0; i < currentMarkers.length; i++) { 
      if (currentMarkers[i].nodeId == nodeId){
        if (i > -1) { 
          currentMarkers.splice(i, 1); 
      } 
      }
  } 
    this.xdfPlayer.setProgressMarkers(currentMarkers);
  }
  // 删除知识点
  delKnowPoint = async knowPoint => {
    const { noteId, type } = knowPoint;
    await service.delKnoPoint({ noteId });
    await this.getKnoList();
    // 从播放器中删除
    //type === 1 && this.player.removeProgressDot(noteId + '');
    if(type === 1 ){
      this.delPlayerMarkers(noteId + '');
      replayKnowledgePointLog('AC3504', { click: '删除知识点', type: '旧回放' });
    }
    // 有可能是从预览删除的
    this.setState({ previewKnoPointId: '' });
    this.getKnoList();
    knowPoint.type === 2 && this.handleCheckMark();
  }
  handleDelKnowPoint = (deleteConfirmItemId, event) => {
    const itemElement = event.target.closest(`.${styles.knoLi}`);
    const parentElement = itemElement.closest(`.${styles.knoListUl}`);
    // 判断提示气泡出现位置
    if (itemElement && parentElement) {
      const itemRect = itemElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();
      const distanceFromTop = itemRect.top - parentRect.top;
      this.setState({ 
        deleteConfirmItemId,
        isTipNearTop: distanceFromTop < 84
      });
    } else {
      this.setState({ deleteConfirmItemId });
    }
  }
  cancelDelKnowPoint = () => {
    this.setState({ 
      deleteConfirmItemId: null,
      isTipNearTop: false
    });
  }

  // 点击其他地方关闭删除确认气泡
  handleTipOutsideClick = (event) => {
    if (this.state.deleteConfirmItemId) {
      // 内部dom或本身
      const isClickInsideTip = event.target.closest(`.${styles.knoDelTip}`);
      const isClickOnDeleteBtn = event.target.closest(`.${styles.knoDel}`);
      if (!isClickInsideTip && !isClickOnDeleteBtn) {
        this.cancelDelKnowPoint();
      }
    }
  }
  shareKnowPoint = async knowPoint => {
    let res = await service.getShareUrl({ noteId: knowPoint.noteId, isLimit: 0 });
    this.setState({ showShare: true, shareUrl: res.shareUrl, shareNoteId: knowPoint.noteId });
  }
  onCloseShare = close => {
    this.setState({ showShare: close, shareUrl: '', shareNoteId: 0 });
  }
  onShareLimit = throttle(async checked => {
    let res = await service.getShareUrl({ noteId: this.state.shareNoteId, isLimit: checked === true ? 1 : 0 });
    this.setState({ shareUrl: res.shareUrl });
  }, 2000);

  onShareSuccess = (limit) => {
    replayKnowledgePointLog('AC3505', { click: '分享知识点', type: limit ? '仅限本班分享' : '任何人可查看分享', desc: '旧回放' });
  }
  // 编辑知识点
  editKnowPoint = knowPoint => {
    // replayKnowledgePointLog('RB1023', { function: 1 }); // 点击编辑知识点
    this.editKnowPointBegin = Math.floor(Date.now() / 1000);
    replayKnowledgePointLog('AC3503', { click: '编辑知识点', type: '入口', desc: '旧回放' });
    this.setState(state => {
      let t1 = knowPoint.startTime;
      let t2 = knowPoint.endTime;
      let p1 = (t1 / state.totalTime * 100).toFixed(2);
      let p2 = (t2 / state.totalTime * 100).toFixed(2);
      return { sliderWidth: state.controlBarWidth, sliderValue: [p1, p2], selecting: true };
    }, () => {
      this.setState({ allowCross: false });
    });
    this.setState({ isUpdateKno: true, isEditingKnowPoint: knowPoint });
  }
  isCoincide = (type, _startTime, _endTime) => {
    let list = type === 1 ? this.state.knowledgeList.filter(kno => kno.noteId !== this.state.isEditingKnowPoint.noteId) : this.state.knowledgeList;
    let intersect = list.some(k => (_startTime > k.startTime && _startTime < k.endTime) || (_endTime > k.startTime && _endTime < k.endTime));
    let include = list.some(k => k.startTime >= _startTime && k.endTime <= _endTime);
    return intersect || include;
  }
  // 保存或者确认新增 1-编辑 2-新增
  saveKno = async type => {
    let { hourStart, minuteStart, secondStart, hourEnd, minuteEnd, secondEnd, _startTime, _endTime } = this.handleInputTime();
    if (_startTime > this.state.totalTime || _endTime > this.state.totalTime) {
      toast('已超过视频时长，请重新输入');
      return;
    }
    if (_startTime >= _endTime) {
      toast('起始时间大于结束时间，请重新输入');
      return;
    }
    if (hourStart > 23 || hourEnd > 23 || minuteStart > 59 || secondStart > 59 || minuteEnd > 59 || secondEnd > 59) {
      toast('输入不正确，请重新输入');
      return;
    }
    if (this.isCoincide(type, _startTime, _endTime)) {
      toast(intl.get('REPLAY_KNOWLEDGE_POINT_NO_REPEAT'));
      return;
    }
    const { noteId, startTime, endTime, note } = this.state.isEditingKnowPoint;
    if (type === 1) {
      await service.editKnowPoint({ noteId, startTime, endTime, note });
      console.log("-----noteId",noteId);
      // 播放器不支持编辑，可以先删除然后新增
      //this.player.removeProgressDot(noteId);
      //this.player.addProgressDot(startTime, noteId, endTime - startTime);
      this.delPlayerMarkers(noteId);
      console.log("delPlayerMarkers time", this.state.isEditingKnowPoint.startTime);
      var currentMarkers = this.xdfPlayer.getProgressMarkers();
      currentMarkers.push({offset:Math.floor(startTime),text:'',nodeId: noteId});
      this.xdfPlayer.setProgressMarkers(currentMarkers);
      // replayKnowledgePointLog('RB1023', {function: 2}); // 保存编辑知识点
      const editKnoPointEnd = Math.floor(Date.now() / 1000);
      const editduration = editKnoPointEnd - this.editKnowPointBegin;
      replayKnowledgePointLog('AC3503', { click: '编辑知识点', type: '保存', desc: '旧回放', stay_duration: editduration + '' });
    }
    if (type === 2) {
      const { noteId } = await service.addKnoPoint({ classroomId: this.classroomId, type: 1, startTime, endTime, note });
      //this.player.addProgressDot(startTime, noteId, endTime - startTime);
      var currentMarkers = this.xdfPlayer.getProgressMarkers();
      currentMarkers.push({offset:Math.floor(startTime),text:'',nodeId: noteId});
      this.xdfPlayer.setProgressMarkers(currentMarkers);
      // replayKnowledgePointLog('RB1024', { function: 2 }); // 保存新增知识点
      const addKnoPointEnd = Math.floor(Date.now() / 1000);
      const addduration = addKnoPointEnd - this.addKnoPointBegin;
      replayKnowledgePointLog('AC3502', { click: '新增知识点', type: '确认新增',  desc: '旧回放', stay_duration: addduration + '' });
    }
    await this.getKnoList();
    this.handleCancelEdit();
    this.setState({ selecting: false });
  }
  // 取消新增或编辑
  handleCancelEdit = () => {
    this.setState({ isUpdateKno: false, selecting: false, isEditingKnowPoint: null });
  }
  // 知识点速览
  quickReadKno = () => {
    const { knowledgeList } = this.state;
    // 从第一个开始速览播放
    this.setState({ isQuickRead: true, isPlayingId: knowledgeList[0].noteId, showKnowledgeDialog: false });
    this.playKnowPoint(knowledgeList[0]);
    this.QuickReadIndex = knowledgeList[0];
    replayKnowledgePointLog('RB1022', {function: 1}); // 开始速览
  }
  // 某个知识点播放完成的回调 用于回显
  playedCallback = id => {
    const { isQuickRead, knowledgeList } = this.state;
    // 如果不是在速览模式
    if (!isQuickRead) {
      this.setState({ isPlayingId: '' });
      return;
    }
    if (id === knowledgeList[knowledgeList.length - 1].noteId) {
      this.finishQuickRead();
      //this.player.pause();
      this.Pause();
      return;
    }
    // 如果是在速览， 则继续播放下一个
    const index = knowledgeList.findIndex(item => item.noteId === id);
    this.playKnowPoint(knowledgeList[index + 1]);
    this.QuickReadIndex = knowledgeList[index + 1];
  }
  // 播放知识点
  playKnowPoint = knowPoint => {
    const { startTime, endTime, noteId } = knowPoint;
    this.setState({ isPlayingId: noteId });
   // 调用播放器接口，开始播放，播放器判断这个知识点什么时候播放完，播放完会执行事件
    //this.player.currentTime = startTime;
    //this.player.play();
    this.Seek(startTime);
    this.Play();
    replayKnowledgePointLog('RB1021', { function: 3 }); // 点击某个知识点
  }
  // 结束速览
  finishQuickRead = () => {
    this.setState({ isQuickRead: false, isPlayingId: '' });
    this.QuickReadIndex = null;
  }
  onMark = () => {
    //this.currentTime = this.player.currentTime;
    this.currentTime = this.xdfPlayer.getCurrentTime();
    let pos = this.getMarkPos(this.currentTime, this.state.controlBarWidth, this.state.totalTime, this.markBottom);
    if (pos[0] <= this.markDialogHalfWidth) pos = [this.markDialogHalfWidth - this.controlBarOffsetLeft, pos[1]];
    if (pos[0] >= (this.state.controlBarWidth + this.controlBarOffsetLeft - this.markDialogHalfWidth))
      pos = [this.state.controlBarWidth + this.controlBarOffsetLeft - this.markDialogHalfWidth, pos[1]];
    let time = formatTime(this.currentTime);
    this.setState({ markPosition: pos, currentMarkTime: time, showNewMarkDialog: true });
  }
  onCloseMarkDialog = () => {
    this.setState({ showNewMarkDialog: false });
  }
  addMark = async remarkType => {
    let data = {
      classroomId: this.classroomId,
      type: 2,
      remarkType,
      startTime: Math.floor(this.currentTime),
      endTime: Math.floor(this.currentTime),
      note: ''
    };
    await service.addKnoPoint(data);
    this.getKnoList();
    this.setState({ showNewMarkDialog: false });
    replayKnowledgePointLog('RB1027'); // 成功保存
  }
  addAnswerSheet = async () => {
    let data = {
      classroomId: this.classroomId,
      type: 3, // 答题卡
      // remarkType: 3,
      startTime: this.state.quizItem.sendTime,
      endTime: this.state.quizItem.sendTime,
      note: '',
      quizId: this.state.quizItem.quizId
    };
    let res = await service.addKnoPoint(data);
    toast('答题卡添加成功')
    // 答题卡编辑埋点
    replayKnowledgePointLog('AC3004', { click: '确认新增'});
    this.getKnoList();
    this.setState({ showAnswerSheetDialog: false });
    //this.player.addProgressDot(this.state.quizItem.sendTime, res.noteId, 2, { type: 3 });
    var currentMarkers = this.xdfPlayer.getProgressMarkers();
    currentMarkers.push({offset:Math.floor(this.state.quizItem.sendTime),text:'',nodeId: res.noteId, color: '#FFCA8B'});
    this.xdfPlayer.setProgressMarkers(currentMarkers);
    //this.player.showDot(false);

    console.log("---------setProgressMarkers time:", this.state.quizItem.sendTime);
  }
  _editAnswerSheet = async () => {
    let param = {
      noteId: this.state.previewAnswerSeq,
      quizId: this.state.quizItem.quizId,
      startTime: this.state.quizItem.sendTime,
      endTime: this.state.quizItem.sendTime,
    };
    await service.editKnowPoint(param);
    toast('编辑成功');
    // 答题卡编辑埋点
    replayKnowledgePointLog('AC3004', { click: '确认编辑' });
    this.setState({ showAnswerSheetDialog: false });
    this.getKnoList();
    //this.player.removeProgressDot(this.state.previewAnswerSeq);
    //this.player.addProgressDot(this.state.quizItem.sendTime, this.state.previewAnswerSeq, 2, { type: 3 });
    //this.player.showDot(false);
    //this.player.play();
    this.delPlayerMarkers(this.state.previewAnswerSeq);
    var currentMarkers = this.xdfPlayer.getProgressMarkers();
    currentMarkers.push({offset:Math.floor(this.state.quizItem.sendTime),text:'',nodeId:this.state.previewAnswerSeq, color: '#FFCA8B'});
    this.xdfPlayer.setProgressMarkers(currentMarkers);
    this.Play();
  }
  cancelAnswerSheet = () => {
    this.setState(state => {
      return {
        showAnswerSheetDialog: false,
        updateAnswer: false,
        previewAnswerId: state.isAnswerMini ? state.previewAnswerId : '',
        previewAnswerSeq: state.isAnswerMini ? state.previewAnswerSeq : '',
      }
    });
    //this.player.showDot(false);
  }
  onPreviewAnswer = (quizSeq, quizId) => {
    this.setState({
      previewAnswerSeq: quizSeq,
      previewAnswerId: quizId,
    });
  }
  delAnswerSheet = async (quizSeq) => {
    let res = await service.delKnoPoint({ noteId: quizSeq });
    console.log("------res",res);
    toast('删除成功');
    replayKnowledgePointLog('AC3004', { click: '确认删除' });
    this.getKnoList();
    //this.player.removeProgressDot(quizSeq + '');
    this.delPlayerMarkers(quizSeq + '');

    this.setState({
      previewAnswerId: false,
    });
    //this.player.showDot(false);
    //this.player.play();
    this.Play();
  }
  editAnswerSheet = async (quizId) => {
    let cur = this.state.testQuizList.find(item => item.quizId === quizId);
    let _cur = this.state.quizList.find(item => item.quizId === quizId);
    let _index = this.state.quizList.findIndex(item => item.quizId === quizId);
    this.setState({
      quizItem: cur,
      updateAnswer: true,
      showAnswerSheetDialog: true,
      previewAnswerId: false,
      // quizList: res.quizList,
      selectedValue: { ..._cur, index: _index },
    });
  }
  getQuizList = async () => {
    const { cid: classroomId } = searchParam;
    const res = await service.getQuizList({ classroomId: +classroomId });
    this.setState({
      quizList: (res.quizList || []).sort((a, b) => a.sendTime - b.sendTime),
      quizItem: res.quizList[0] || {},
      selectedValue: { ...(res.quizList[0] || {}), index: 1 }
    });
  }
  openAnswerSheetDialog = () => {
    if (!this.state.quizList || this.state.quizList.length <= 0) {
      toast('该节课没有发放答题卡');
      return;
    }
    this.setState(state => {
      return {
        showAnswerSheetDialog: !this.state.showAnswerSheetDialog,
        //quizItem: { ...state.quizItem, sendTime: Math.floor(this.player.currentTime || 0) }
        quizItem: { ...state.quizItem, sendTime: Math.floor(this.xdfPlayer.getCurrentTime() || 0) }
      }
    });
  }
  handleCancelAnswerSheet = () => {
    this.setState(state => {
      return {
        showAnswerSheetDialog: !this.state.showAnswerSheetDialog,
        updateAnswer: false,
        previewAnswerId: state.isAnswerMini ? state.previewAnswerId : '',
        previewAnswerSeq: state.isAnswerMini ? state.previewAnswerSeq : '',
      }
    });
    replayKnowledgePointLog('RB1021', {function: 2}); // 关闭知识点页面
    //this.player.showDot(false);
  }
  onCloseAnswerDialog = () => {
    this.setState({
      previewAnswerId: '',
      previewAnswerSeq: '',
    });
    //this.player.showDot(false);
    //this.player.play();
    this.Play();
  }
  onCloseExternalQuestion = () => {
    this.setState({
      currentExternalQuestion: null
    })
    //this.player.showDot(false);
    //this.player.play();
    this.Play();
  }
  handleAnswerMini = () => {
    this.setState({
      isAnswerMini: true,
    });
  }
  onAnswerMini = () => {
    this.setState({
      isAnswerMini: false,
    });
  }
  handleSelect = () => {
    this.setState({
      selectShow: !this.state.selectShow
    });
  }
  handleSelectOption = (item, index) => {
    this.setState(state => {
      return {
        selectShow: false,
        selectedValue: { ...item, index },
        quizItem: { ...item, sendTime: state.quizItem.sendTime }
      }
    });
  }
  getMarkPos = (startTime, totalWidth, totalTime, posY) => {
    return [Math.floor(startTime * 1000000 * totalWidth / totalTime) / 1000000, posY];
  }

  handleMarkList = (markList, width) => {
    return markList.map(m => ({ ...m, pos: this.getMarkPos(m.startTime, width, this.state.totalTime, this.markBottom) })) || [];
  }
  handleResize = () => {
    // this.setState(state => {
    //   let list = this.handleMarkList(state.markList, state.controlBarWidth);
    //   return { markList: list };
    // });

    // resize后，重新计算下载讲义弹窗位置
    setTimeout(() => {
      if (this.state.handoutModalInfo.visible) {
        this.setState((prevState) => ({
          handoutModalInfo: {
            ...prevState.handoutModalInfo,
            wrapStyle: this.calcHandoutModalPosition()
          }
        }))
      }
    }, 0);
  }
  onCheckMark = mark => {
    let { pos } = mark;
    if (pos[0] <= this.markDialogHalfWidth) pos = [this.markDialogHalfWidth - this.controlBarOffsetLeft, pos[1]];
    if (pos[0] >= (this.state.controlBarWidth + (this.controlBarOffsetLeft + this.controlBarOffsetRight) - this.markDialogHalfWidth))
      pos = [this.state.controlBarWidth + (this.controlBarOffsetLeft + this.controlBarOffsetRight) - this.markDialogHalfWidth, pos[1]];
    this.setState({ currentMark: { ...mark, pos }});
  }
  handleCheckMark = () => {
    this.setState({ currentMark: '' });
    //this.player.showDot(false);
    //this.player.play();
    this.Play();
  }
  // 退出预览知识点
  handleCancelPreview = () => {
    this.setState({ previewKnoPointId: '' });
    //this.player.showDot(false);
    //this.player.play();
    this.Play();
  }
  // 预览时候的跳到这里事件
  goKnowPoint = () => {
    const { knowledgeList, previewKnoPointId } = this.state;
    const kno = knowledgeList.find(item => item.noteId === previewKnoPointId);
    this.finishQuickRead();
    this.playKnowPoint(kno);
    this.setState({ previewKnoPointId: '' });
    replayKnowledgePointLog('RB1020'); // 知识点里面点击跳到该处
    //this.player.showDot(false);
  }
  onRangeChange = value => {
    this.setState({ sliderValue: value });
  }
  onRangeAfterChange = value => {
    if (value[0] !== this.leftSliderValue) //this.player.currentTime = value[0] * this.state.totalTime / 100;
      this.Seek(value[0] * this.state.totalTime / 100);
    let t1 = value[0] * this.state.totalTime / 100;
    let t2 = value[1] * this.state.totalTime / 100;
    this.setState(state => {
      return { isEditingKnowPoint: { ...state.isEditingKnowPoint, startTime: t1, endTime: t2 }};
    });
    this.leftSliderValue = value[0] || 0;
  }
  isTeaOrAss = () => {
    const { role } = searchParam;
    return (+role === 1 || +role === 2)
  }
  onScreenShot = () => {
    service.sendApp('takeSnapshot', JSON.stringify({}));
  }
  onCloseWindow = () => {
    service.closeWindow('CloseWindow', JSON.stringify({}))
  }
  swiperMark = (mark, number) => {
    this.setState(state => {
      let index = state.markList.findIndex(m => m.noteId === mark.noteId) + number;
      if (index < 0 || index === state.markList.length) return {};
      let targetMark = state.markList[index];
      return { currentMark: targetMark };
    });
  }
  openChatDialog = () => {
    this.setState({ showChatDialog: true });
    replayKnowledgePointLog('RB1025', {function: 1}); // 打开聊天记录
  }
  handleCancelChat = () => {
    this.setState({ showChatDialog: !this.state.showChatDialog });
    replayKnowledgePointLog('RB1025', {function: 2}); // 关闭聊天记录
  }
  getWindowWidth = () => {
    let windowWidth;
    if (window.innerWidth) windowWidth = window.innerWidth;
    else if ((document.body) && (document.body.clientWidth)) windowWidth = document.body.clientWidth;
    return windowWidth;
  }
  handleKeyPress = event => {
    if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(event.key)) event.preventDefault();
    else return true;
  }
  onInputBlur = event => {
    if (event.target.value === '') document.getElementById(event.target.id).value = '00';
  }
  _handleKeyPress = event => {
    if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(event.key)) event.preventDefault();
    else return true;
  }
  _onInputBlur = event => {
    if (event.target.value === '') document.getElementById(event.target.id).value = '00';
  }
  getValue = id => document.getElementById(id).value;
  handleInputTime = () => {
    let hourStart = this.getValue('hour-start');
    let minuteStart = this.getValue('minute-start');
    let secondStart = this.getValue('second-start');
    let hourEnd = this.getValue('hour-end');
    let minuteEnd = this.getValue('minute-end');
    let secondEnd = this.getValue('second-end');
    let _startTime = +hourStart * 60 * 60 + +minuteStart * 60 + +secondStart;
    let _endTime = +hourEnd * 60 * 60 + +minuteEnd * 60 + +secondEnd;
    return { hourStart: +hourStart, minuteStart: +minuteStart, secondStart: +secondStart,
      hourEnd: +hourEnd, minuteEnd: +minuteEnd, secondEnd: +secondEnd, _startTime, _endTime };
  }
  _handleInputTime = () => {
    let hourStart = this.getValue('hour-send-time');
    let minuteStart = this.getValue('minute-send-time');
    let secondStart = this.getValue('second-send-time');
    let _startTime = +hourStart * 60 * 60 + +minuteStart * 60 + +secondStart;
    return { hourStart: +hourStart, minuteStart: +minuteStart, secondStart: +secondStart, _startTime };
  }
  onInputChange = (event, type) => {
    let { value } = event.target;
    if (+value < 0) {
      toast('输入不正确，请重新输入');
      return;
    }
    // if (type === 'HH') {
    //   if (+value > 23) {
    //     toast('输入不正确，请重新输入');
    //     return;
    //   }
    // }
    if (type === 'mm' || type === 'ss') {
      if (+value > 59) {
        toast('输入不正确，请重新输入');
        return;
      }
    }
    let { _startTime, _endTime } = this.handleInputTime();
    if (_startTime > this.state.totalTime || _endTime > this.state.totalTime) {
      toast('已超过视频时长，请重新输入');
      return;
    }
    // if (_startTime >= _endTime) {
    //   toast('起始时间大于结束时间，请重新输入');
    //   return;
    // }
    this.setState(state => {
      let p1 = (_startTime / state.totalTime * 100).toFixed(2);
      let p2 = (_endTime / state.totalTime * 100).toFixed(2);
      return {
        sliderValue: [p1, p2],
        isEditingKnowPoint: { ...state.isEditingKnowPoint, startTime: _startTime, endTime: _endTime }
      };
    }, () => {
      this.setState({ allowCross: false });
    });
    //this.player.currentTime = _startTime;
    //this.player.play();
    this.xdfPlayer.seek(_startTime);
    this.Play();
  }
  _onInputChange = (event, type) => {
    let { value } = event.target;
    if (+value < 0) {
      toast('输入不正确，请重新输入');
      return;
    }
    // if (type === 'HH') {
    //   if (+value > 23) {
    //     toast('输入不正确，请重新输入');
    //     return;
    //   }
    // }
    if (type === 'mm' || type === 'ss') {
      if (+value > 59) {
        toast('输入不正确，请重新输入');
        return;
      }
    }
    let { _startTime } = this._handleInputTime();
    if (_startTime > this.state.totalTime) {
      toast('已超过视频时长，请重新输入');
      return;
    }
    // if (_startTime >= _endTime) {
    //   toast('起始时间大于结束时间，请重新输入');
    //   return;
    // }
    this.setState(state => {
      return {
        quizItem: {...state.quizItem, sendTime: _startTime}
      }
    });
  }

  // 计算下载讲义弹窗的位置
  calcHandoutModalPosition = () => {
    const handoutBtnEl = this.handoutBtnRef.current;
    if (!handoutBtnEl) { return; }
    const { width, height, right, bottom } = handoutBtnEl.getBoundingClientRect();
    return {
      left: right - width / 2,
      top: bottom - height - 40
    }
  }

  // 展示下载讲义弹窗
  onShowHandoutModal = (e) => {
    this.setState({
      handoutModalInfo: {
        visible: true,
        wrapStyle: this.calcHandoutModalPosition()
      }
    })
    this.setState((prevState) => ({
      handoutModalInfo: {
        ...prevState.handoutModalInfo,
        visible: true
      }
    }))
  }

  // 关闭下载讲义弹窗
  onCloseHandoutModal = () => {
    this.setState((prevState) => ({
      handoutModalInfo: {
        ...prevState.handoutModalInfo,
        visible: false
      }
    }))
  }


  markElement = mark => (
    <div className={styles.markContainer}>
      <p className={styles.markTime}>{mark ? formatTime(mark.startTime) : this.state.currentMarkTime}</p>
      {mark
        ? <>
            <p className={styles.hoverMarkContainer}>
              <span style={{ display: this.state.markList.length > 1 ? 'block': 'none' }} className={styles.editMarkIcon} onClick={() => this.swiperMark(mark, -1)}></span>
              <span className={styles.editTxt}>
                <span className={[styles.markTypeIcon, mark.remarkType === 2 ? styles.focusMarkTypeIcon : ''].join(' ')}></span>
                {mark.remarkType === 1 ? `${intl.get('REPLAY_KNOWLEDGE_POINT_HIGHLIGHT')}` : `${intl.get('REPLAY_KNOWLEDGE_POINT_DIFFICULT')}`}
              </span>
              <span style={{ display: this.state.markList.length > 1 ? 'block': 'none' }} className={[styles.editMarkIcon, styles.nextEditMarkIcon].join(' ')}
              onClick={() => this.swiperMark(mark, +1)}></span>
            </p>
            <button className={styles.knoBtn1} onClick={() => this.delKnowPoint(mark)}>{intl.get('REPLAY_KNOWLEDGE_POINT_DELETE_TAG')}</button>
          </>
        : <>
          {this.state.markList.find(m => m.startTime === Math.floor(this.currentTime))
            ? <p className={styles.noRepeatContent}>
              <span className={styles.noRepeatTitle}>{intl.get('REPLAY_KNOWLEDGE_POINT_TIP_ADDED')}</span>
              <button className={styles.knoBtn1} onClick={() => { this.setState({ showNewMarkDialog: false }); }}>{intl.get('REPLAY_KNOWLEDGE_POINT_I_KNOW')}</button>
            </p>
            : <p className={styles.markContent}>
              <span className={styles.markBtn} onClick={() => this.addMark(1)}>
                <span className={[styles.markIcon, styles.difficulty].join(' ')}></span>
                <span className={styles.txt}>{intl.get('REPLAY_KNOWLEDGE_POINT_HIGHLIGHT')}</span>
              </span>
              <span className={styles.markBtn} onClick={() => this.addMark(2)}>
                <span className={[styles.markIcon, styles.focus].join(' ')}></span>
                <span className={styles.txt}>{intl.get('REPLAY_KNOWLEDGE_POINT_DIFFICULT')}</span>
              </span>
            </p>
          }
        </>
      }
    </div>
  )
  timerInput = (id, time, timeType) => (
    <input id={id} type="tel" className={styles.timeInput} placeholder='' autoComplete="off" defaultValue={time} value={time}
      onKeyPress={this.handleKeyPress} onBlur={this.onInputBlur} onChange={(event) => this.onInputChange(event, timeType)} />
  )
  _timerInput = (id, time, timeType) => (
    <input id={id} type="tel" className={styles.timeInput} placeholder='' autoComplete="off" defaultValue={time} value={time}
      onKeyPress={this._handleKeyPress} onBlur={this._onInputBlur} onChange={(event) => this._onInputChange(event, timeType)} />
  )

  render () {
    const { showKnowledgeDialog, quizItem, showAnswerSheetDialog, showNewMarkDialog, knowledgeList, isPlayingId, isEditingKnowPoint, isQuickRead, previewKnoPointId, previewKnoPosition, previewAnswerSeq, previewAnswerPosition, showChatDialog, handoutInfo, handoutModalInfo, deleteConfirmItemId, isTipNearTop } = this.state;
    const { theme } = this.props;
    const noKnoPoint = (
      <div className={styles.noKnoPoint}>
        <img src={themeImg['no-knowledge'][theme]} alt="无知识点" />
        <div className={styles.noKnoNote}>{intl.get('REPLAY_KNOWLEDGE_POINT_TIP_ADD')}</div>
        {this.isTeaOrAss() && <button className={styles.knoBtn1} onClick={this.handleKnowledge}>{intl.get('REPLAY_KNOWLEDGE_POINT_ADD')}</button>}
      </div>
    )
    const knoList = (
      <div className={styles.knoList}>
        <ul className={styles.knoListUl}>
          {knowledgeList.map(item =>
            <li key={item.noteId} onClick={() => this.playKnowPoint(item)}
            className={`${styles.knoLi} ${(!isQuickRead && item.noteId === isPlayingId) ? styles.knoIsPlaying:''} ${isQuickRead && item.noteId === isPlayingId? styles.isQuickReadKno: ''}`}>
              <div className={styles.knoTime}>{formatTime(item.startTime)}-{formatTime(item.endTime)}</div>
              <div className={styles.knoContent}>{item.note}</div>
              {this.isTeaOrAss() &&
                <div className={styles.knoEditBtns}>
                  <i className={styles.knoEdit} onClick={(e) => { e.stopPropagation(); this.editKnowPoint(item); }}></i>
                  {process.env.ORG !=='meike' && <i className={styles.knoShare} onClick={e => { e.stopPropagation(); this.shareKnowPoint(item); }}></i>}
                  <i className={styles.knoDel} onClick={(e) => { e.stopPropagation(); this.handleDelKnowPoint(item?.noteId, e); }}></i>
                </div>
              }
              {item?.noteId === deleteConfirmItemId && <div className={`${styles.knoDelTip} ${isTipNearTop ? styles.knoDelTipBottom : ''}`}>
                <div className={styles.knoDelTipTitle}>{intl.get('REPLAY_KNOWLEDGE_POINT_DELETE_TIP')}</div>
                <div className={styles.knoDelTipBtnList}>
                  <span className={styles.knoDelTipBtn} onClick={(e) => { e.stopPropagation(); this.cancelDelKnowPoint(); }}>{intl.get('CANCEL_TEXT')}</span>
                  <span className={styles.knoDelTipBtn} onClick={(e) => { e.stopPropagation(); this.delKnowPoint(item); }}>{intl.get('OK_TEXT')}</span>
                </div>
                <div className={styles.triangle}></div>
              </div>}
            </li>
          )}
        </ul>
        <div className={styles.knoBtns}>
          {isQuickRead
            ? <button className={styles.knoBtn1} onClick={() => {
                replayKnowledgePointLog('RB1022', {function: 2}); // 点击结束速览
                this.finishQuickRead();
              }}>{intl.get('REPLAY_KNOWLEDGE_POINT_END')}</button>
            : <>
                {this.isTeaOrAss() && <button className={styles.knoBtn1} onClick={this.handleKnowledge}>{intl.get('REPLAY_KNOWLEDGE_POINT_ADD')}</button>}
                <button className={styles.knoBtn2} onClick={this.quickReadKno}>{intl.get('REPLAY_KNOWLEDGE_POINT_PLAY')}</button>
              </>
          }
        </div>
      </div>
    )
    const answerSheet = (
      <div className={styles.answerSheetContainer}>
        {/* <p style={{ color: '#fff' }}>{`id:${this.state.quizItem.quizId}-seq:${this.state.previewAnswerSeq}`}</p> */}
        <div className={styles.timeWrap}>
          <span className={styles.timeTitle}>答题卡出现时间</span>
          <span className={styles.timeContent}>
            {this._timerInput('hour-send-time', formatTime(Math.floor(quizItem.sendTime || 0), {format: 'HH:mm:ss'}).split(':')[0], 'HH')}
            <span className={styles.timeTip}>时</span>
            {this._timerInput('minute-send-time', formatTime(Math.floor(quizItem.sendTime || 0), {format: 'HH:mm:ss'}).split(':')[1], 'mm')}
            <span className={styles.timeTip}>分</span>
            {this._timerInput('second-send-time', formatTime(Math.floor(quizItem.sendTime || 0), {format: 'HH:mm:ss'}).split(':')[2], 'ss')}
            <span className={styles.timeTip}>秒</span>
          </span>
        </div>
        <div className={styles.topicWrap}>
          <span className={styles.topicTitle}>选择题目</span>
          <div className={styles.selectWrap}>
            <div className={styles.selectHeader} onClick={this.handleSelect}>
              <span className={styles.selected}>
                {`${this.state.selectedValue.sendTime < 0 ? '课前' : ''}答题卡${this.state.selectedValue.index + 1}（${formatTime(Math.floor(Math.abs(this.state.selectedValue.sendTime) || 0), {format: 'HH:mm:ss'})}）`}
                </span>
              <span className={this.state.selectShow ? styles.selectedIconUp : styles.selectedIconDown}></span>
            </div>
            {
              this.state.selectShow &&
              <div className={styles.optionContainer}>
                <div className={styles.optionContent}>
                {this.state.quizList.map((item, index) =>
                  <p className={[styles.option, item.quizId === this.state.selectedValue.quizId ? styles.curOption : ''].join(' ')} onClick={() => this.handleSelectOption(item, index)}>
                    {`${item.sendTime < 0 ? '课前' : ''}答题卡${index + 1}（${formatTime(Math.floor(Math.abs(item.sendTime) || 0), {format: 'HH:mm:ss'})}）`}
                  </p>
                )}
                </div>
              </div>
            }
          </div>
        </div>
        <div className={styles.contentWrap}>
          <div className={styles.thumbnailWrap}>
            <span className={styles.thumbnailTitle}>题干</span>
            <img src={quizItem.screenshotUrl} className={styles.thumbnail} alt="" />
          </div>
          <div className={styles.listWrap}>
            <span className={styles.listTitle}>正确答案</span>
            <ul className={styles.list}>
              {(quizItem.quizContentList || []).map((item) =>
                <li className={styles.item}>
                  <span>{`第${item.quizNumber}题`}</span>
                  <span>{item.vecAnswer.join('')}</span>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className={styles.btnContainer}>
          <button className={styles.knoBtn1} onClick={this.cancelAnswerSheet}>取消</button>
          <button className={styles.knoBtn2} onClick={this.state.updateAnswer ? this._editAnswerSheet : this.addAnswerSheet}>{this.state.updateAnswer ? '确认编辑' : '新增答题卡'}</button>
        </div>
      </div>
    )
    const previewAnswer = (
      <div className={styles.btnContainer2}>
        <button className={styles.knoBtn1} onClick={() => this.delAnswerSheet(this.state.previewAnswerSeq)}>删除</button>
        <button className={styles.knoBtn2} onClick={() => this.editAnswerSheet(this.state.previewAnswerId)}>编辑</button>
      </div>
    )
    const previewKno = (
      <div className={[styles.knoList, styles.previewKnoList].join(' ')}>
        <ul className={styles.knoListUl} style={{ height: !!this.state.previewKnoPointId ? 'auto' : '320px' }}>
          {knowledgeList.filter(kno => kno.noteId === previewKnoPointId).map(item =>
            <li key={item.noteId} className={[styles.knoLi, styles.previewLi].join(' ')}>
              <div className={styles.knoTime}>{formatTime(item.startTime)}-{formatTime(item.endTime)}</div>
              <div className={styles.knoContent} style={{ width: !!this.state.previewKnoPointId ? 'auto' : '340px' }}>{item.note}</div>
            </li>
          )}
        </ul>
        <div className={styles.knoBtns}>
          {this.isTeaOrAss() &&
            <button className={styles.knoBtn1} onClick={() => this.delKnowPoint(knowledgeList.find(item => item.noteId === previewKnoPointId))}>
            {intl.get('REPLAY_KNOWLEDGE_POINT_DELETE')}</button>
          }
          <button className={styles.knoBtn2} onClick={this.goKnowPoint}>{intl.get('REPLAY_KNOWLEDGE_POINT_HERE')}</button>
        </div>
      </div>
    )
    const updateKnow = (
      <div className={styles.textContainer}>
        <div className={styles.head}>
          {!isEditingKnowPoint
            ? <>
              <button className={styles.select} onClick={this.onSelect}>{intl.get('REPLAY_KNOWLEDGE_POINT_RANGE')}</button>
              <p className={styles.tip}>{intl.get('REPLAY_KNOWLEDGE_POINT_TIP_RANGE')}</p>
            </>
            : <>
              <p className={styles.timeTip}>{intl.get('REPLAY_KNOWLEDGE_POINT_TIME_RANGE')}</p>
              <div className={styles.timeContainer}>
                <span className={styles.startTime}>
                  <span className={styles.timeTxt}>{intl.get('REPLAY_KNOWLEDGE_POINT_START_TIME')}</span>
                  {/* <span className={styles.timeStamp}>{formatTime(Math.floor(isEditingKnowPoint.startTime || 0), {format: 'HH:mm:ss'})}</span> */}
                  <div className={styles.timeInputContainer}>
                    {this.timerInput('hour-start', formatTime(Math.floor(isEditingKnowPoint.startTime || 0), { format: 'HH:mm:ss' }).split(':')[0], 'HH')}
                      :
                      {this.timerInput('minute-start', formatTime(Math.floor(isEditingKnowPoint.startTime || 0), { format: 'HH:mm:ss' }).split(':')[1], 'mm')}
                      :
                      {this.timerInput('second-start', formatTime(Math.floor(isEditingKnowPoint.startTime || 0), { format: 'HH:mm:ss' }).split(':')[2], 'ss')}
                  </div>
                </span>
                <span className={styles.splitLine}></span>
                <span className={styles.startTime}>
                  <span className={styles.timeTxt}>{intl.get('REPLAY_KNOWLEDGE_POINT_END_TIME')}</span>
                  {/* <span className={styles.timeStamp}>{formatTime(Math.floor(isEditingKnowPoint.endTime || 0), {format: 'HH:mm:ss'})}</span> */}
                  <div className={styles.timeInputContainer}>
                    {this.timerInput('hour-end', formatTime(Math.floor(isEditingKnowPoint.endTime || 0), { format: 'HH:mm:ss' }).split(':')[0], 'HH')}
                      :
                      {this.timerInput('minute-end', formatTime(Math.floor(isEditingKnowPoint.endTime || 0), { format: 'HH:mm:ss' }).split(':')[1], 'mm')}
                      :
                      {this.timerInput('second-end', formatTime(Math.floor(isEditingKnowPoint.endTime || 0), { format: 'HH:mm:ss' }).split(':')[2], 'ss')}
                  </div>
                </span>
              </div>
            </>
          }
        </div>
        <div className={styles.content}>
          <textarea className={styles.textarea} placeholder={intl.get('REPLAY_KNOWLEDGE_POINT_INPUT')} maxLength={200} onChange={this.onTextareaChange}
          disabled={!this.state.isEditingKnowPoint?.endTime ? true : false} value={isEditingKnowPoint ? isEditingKnowPoint.note : ''}></textarea>
          <span className={styles.count}>{isEditingKnowPoint ? isEditingKnowPoint.note.length : 0}/200</span>
        </div>
        <div className={styles.editContainer}>
          {/*只有编辑的时候有返回按钮 判断编辑还是新增  isEditingKnowPoint.noteId是否存在*/}
          {!!knowledgeList.length && <button className={styles.knoBtn1} onClick={() => this.handleCancelEdit()}>{intl.get('REPLAY_KNOWLEDGE_POINT_BACK')}</button>}
          {isEditingKnowPoint && isEditingKnowPoint.noteId
            ? <button className={[styles.knoBtn2, !isEditingKnowPoint.note ? styles.disabledAddBtn : ''].join(' ')} onClick={() => this.saveKno(1)}>{intl.get('REPLAY_KNOWLEDGE_POINT_SAVE')}</button>
            : <button className={[styles.knoBtn2, !(isEditingKnowPoint && isEditingKnowPoint.note) ? styles.disabledAddBtn : ''].join(' ')} onClick={() => this.saveKno(2)}>{intl.get('REPLAY_KNOWLEDGE_POINT_ADDED')}</button>
          }
        </div>
      </div>
    )

    return (
      <div className={styles.container} id="knowledgePointPlayback">
        <div id="xdf-player"></div>
        {/* 知识点列表页 || 无知识点弹窗start  */}
        <KnowledgeDialog show={showKnowledgeDialog} position={{'zIndex': 116}} handleCancel={this.handleCancelKnoDialog}>
          {this.state.isUpdateKno ? updateKnow : <>{knowledgeList.length ? knoList : noKnoPoint}</>}
        </KnowledgeDialog>
        {/* 知识点列表页 || 无知识点弹窗end  */}
        {/* 答题卡弹窗start  */}
        <KnowledgeDialog isNeedTitleIcon={false} title={'答题卡'} show={showAnswerSheetDialog} position={{ 'width': '420px', 'zIndex': 116}} handleCancel={this.handleCancelAnswerSheet}>
          {quizItem && answerSheet}
        </KnowledgeDialog>
        {/* 答题卡弹窗end  */}
        {/* 第三方课件弹窗 start*/}
        <ExternalQuestionDialog currentExternalQuestion={this.state.currentExternalQuestion} classroomId={this.classroomId} closeDialog={this.onCloseExternalQuestion} uid={this.props.userInfo.userId || +searchParam.uid || 0} roleId={this.state.role} nickName={this.state.nickName} />
        {/* 第三方课件弹窗 end*/}
        {/* 标记点查看弹窗 start */}
        <KnowledgeDialog isNeedTitleIcon={false} title={`${intl.get('REPLAY_KNOWLEDGE_POINT_MARK')}`} show={showNewMarkDialog} handleCancel={this.onCloseMarkDialog}
          position={{ height: 'auto', right: 'auto', bottom: `${this.state.markPosition[1] + 10}px`,
            left: `${this.state.markPosition[0] + this.controlBarOffsetLeft - this.markDialogHalfWidth}px`}}>
          {this.markElement()}
        </KnowledgeDialog>
        {/* 标记点查看弹窗 end */}
        {/* 预览知识点弹窗 start */}
        <KnowledgeDialog show={!!previewKnoPointId} position={previewKnoPosition} handleCancel={this.handleCancelPreview}>
          {previewKno}
        </KnowledgeDialog>
        {/* 预览知识点弹窗 end */}
        {/* 答题卡弹窗 start */}
        {!!previewAnswerSeq && !!this.state.previewAnswerId && !this.state.isAnswerMini &&
        <KnowledgeDialog mini={true} handleMini={this.handleAnswerMini} show={!!previewAnswerSeq && !!this.state.previewAnswerId} title={'答题卡'} position={previewAnswerPosition} handleCancel={this.onCloseAnswerDialog}>
          {
            <>
              {/* <p>{`id:${this.state.previewAnswerId}-seq:${this.state.previewAnswerSeq}`}</p> */}
              <iframe id="answer-sheet" title="answer-sheet" width="100%" height={`${[1, 2].includes(this.role) ? '85%' : '100%'}`} style={{ border: 'none', borderRadius: '16px' }}
                src={`${getIFrameUrl}/quiz/#/stuQuizPage?classroomId=${searchParam.cid}&noteId=${this.state.previewAnswerSeq}&authorization=${this.props.token}&role=${this.state.role}`}>
              </iframe>
              {[1, 2].includes(this.state.role) && previewAnswer}
            </>
          }
        </KnowledgeDialog>
        }
        {/* 答题卡弹窗 end */}
        {/* 聊天记录弹窗 start */}
        {this.state.isLogin && <ChatDialog theme={theme} show={showChatDialog} handleCancel={this.handleCancelChat}></ChatDialog>}
        {/* 聊天记录弹窗 end */}
        <div className={styles.footer} id='knowledge-footer'>
          {isQuickRead &&
            <div className={styles.quickRead}>
              <span className={styles.quickReadKno}>{intl.get('REPLAY_KNOWLEDGE_POINT_IN_PLAY')}</span>
              <button className={`${styles.knoBtn1} ${styles.finishQuickRead}`} onClick={() => {
                replayKnowledgePointLog('RB1022', { function: 2 }); // 点击结束速览
                this.finishQuickRead();
              }}>{intl.get('REPLAY_KNOWLEDGE_POINT_END')}</button>
            </div>
          }
          {/*视频右下角工具栏*/}
          {!common.isPhone() && 
          <div style={{ display: ['gen', 'mke'].includes(theme) && this.state.followControlVisible ? 'block' : 'none' } }>            
            {handoutInfo.show && handoutInfo.url && this.state.isLogin && <button ref={this.handoutBtnRef} className={styles.btn} onClick={this.onShowHandoutModal}>下载讲义</button>}
            {[1, 2].includes(this.role) && this.state.isLogin && <button style={{ opacity: this.state.quizList.length > 0 ? '1' : '0.4' }} className={styles.btn} onClick={this.openAnswerSheetDialog}>答题卡</button>}
            {this.state.isLogin && <button className={styles.btn} onClick={this.openKnowledgeDialog}>{intl.get('REPLAY_KNOWLEDGE_POINT_POINT')}</button>}
            {this.state.isLogin && <button className={styles.btn} onClick={this.openChatDialog}>{intl.get('REPLAY_KNOWLEDGE_POINT_CHAT')}</button>}
          </div>}
          {!this.state.isLogin && <button className={styles.btn} onClick={this.login}>登录</button>}
        </div>
        <div style={{ width: `${this.state.sliderWidth}px` }} className={[styles.sliderContainer, this.state.selecting ? styles.showSlider : ''].join(' ')}>
          <Range value={this.state.sliderValue} onChange={this.onRangeChange} onAfterChange={this.onRangeAfterChange}
            trackStyle={[{ height: '1px', borderTop: '1px dotted #fff' }]} handleStyle={[leftRangeHandleStyle, rightRangeHandleStyle]}
            railStyle={{ backgroundColor: 'transparent' }} allowCross={this.state.allowCross}
          />
        </div>
        {!common.isPhone() && <div className={styles.toolContainer}>
          {
            common.isClient && <span className={styles.screenShot} onClick={this.onScreenShot}></span>
          }
          <span className={styles.mark} onClick={this.onMark}></span>
        </div>}
        {this.state.isAnswerMini && <span className={styles.answerMini} onClick={this.onAnswerMini}></span>}
        <>
          {/* {this.state.followControlVisible && this.state.markList.map(mark => */}
          {this.state.markList.map(mark =>
            // <span key={mark.noteId} className={styles.markPoint} onClick={() => this.onCheckMark(mark)}
            <span key={mark.noteId} className={styles.markPoint} onClick={() => {}}
              style={{ left: `${mark.pos[0] + this.markOffset}px`, bottom: `${mark.pos[1]}px`, background: `url(${mark.remarkType === 1 ? focusIcon : difficultyIcon}) 100%/100%` }}>
            </span>
          )}
          {/* 标记点增加弹窗 start */}
          <KnowledgeDialog isNeedTitleIcon={false} title={`${intl.get('REPLAY_KNOWLEDGE_POINT_MARK')}`} show={this.state.currentMark}
            handleCancel={this.handleCheckMark} position={{ height: 'auto', right: 'auto', bottom: '90px',
            left: `${Math.min(Math.max(0, (this.state.currentMark ? this.state.currentMark.pos[0] : 0) + this.controlBarOffsetLeft - this.markDialogHalfWidth), this.getWindowWidth() - this.markDialogHalfWidth * 2)}px` }}>
            {this.markElement(this.state.currentMark)}
          </KnowledgeDialog>
          {/* 标记点增加弹窗 end */}
          </>
  
        <div className={styles.starContainer} style={{ display: ['gen', 'mke'].includes(theme) ? 'block' : 'none',
          opacity: (this.role === 3 && !(this.state.needTime <= 0 || this.state.needTime > this.state.totalTime)) ? '1' : '0'}}>
          <div className={styles.starContentContainer}>
            <div className={styles.progressBar}>
              <div ref={this.progressRef} style={{ width: `${this.state.progressWidth}%` }} className={styles.progress}></div>
            </div>
            <div className={styles.title}>
              <span>{intl.get('REPLAY_KNOWLEDGE_POINT_WATCH')}</span>
              <span>{Math.round((this.state.seenTime >= this.state.needTime ? this.state.needTime : this.state.seenTime) / this.state.needTime * 100)}%</span>
            </div>
          </div>
          <div id="starReward" style={{ width: '150px', height: '150px', position: 'absolute', bottom: '-44px', right: '-86px' }}></div>
          {this.state.starNum && <span className={[styles.starNum, this.state.showStarNum ? styles.animationStarNum : ''].join(' ')}>+{this.state.starNum}</span>}
        </div>
        {this.state.knowledgeList.some(m => (isEditingKnowPoint?.startTime + 2 || 0) >= m?.startTime && (isEditingKnowPoint?.startTime + 2 || 0) <= m?.endTime) &&
          this.state.selecting && !this.state.isUpdateKno &&
          <p className={styles.rangeTip}>{intl.get('REPLAY_KNOWLEDGE_POINT_NO_REPEAT')}</p>
        }
        <Watermark />
        <Confirm show={!this.state.isValid} isLight={true} content={intl.get('REPLAY_KNOWLEDGE_POINT_VALID')}
          confirm={{ text: `${intl.get('REPLAY_KNOWLEDGE_POINT_VALID_BACK')}`, onConfirm: this.onCloseWindow }}
        />
        <ShareDialog show={this.state.showShare} shareUrl={this.state.shareUrl} onCloseShare={this.onCloseShare} onShareLimit={this.onShareLimit} onShareSuccess={this.onShareSuccess} />
        {/*下载讲义弹窗*/}
        <IframeModal
            url={handoutInfo.url + '&token=' + this.props.token}
            visible={handoutModalInfo.visible}
            wrapClassName={styles.handoutModalWrap}
            maskStyle={handoutModalInfo.wrapStyle}
            title="下载讲义"
            closable={true}
            footer={null}
            onCancel={this.onCloseHandoutModal}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...state.common,
  token: state.token
});

export default connect(
  mapStateToProps
)(KnowledgePoint);
